import React from 'react';
import { useSelector } from 'react-redux';
import { getAddToBLTypes } from 'src/slices/addToBLTypes';

// components
import Modal from 'shared/modals/Modal';
import AddToBLForm from '../../forms/AddToBLForm';

const AddToBLModal = ({
  onClose,
  initialValues,
  isSubmitting,
  setSubmitting
}) => {

  const types = useSelector(getAddToBLTypes);

  return (
    <Modal isOpen={true} title={`Add to BL by ${types.find(t => t.value === initialValues.type).description} for Order #${initialValues.orderId}`} handleClose={onClose} containerStyle='medium'>
      <section className={`ccc-standard-form ${isSubmitting ? 'hide-overflow' : ''}`}>
      <AddToBLForm data={initialValues} onClose={onClose} setSubmitting={setSubmitting} />
      </section>
    </Modal>
  );
};

export default AddToBLModal;
